<template>
  <div class="ranking">
    <div class="ranking-container">
      <UiBox :is-empty="isBoxEmpty">
        <template v-slot:nav-left>
          <UiTab
            v-for="(tab, index) in activeTitle"
            :key="index"
            :id="tab.type"
            :active="records === index"
            :class="['tab', tab.type]"
            :data-id="`id-${index}`"
            @click="honorToggle(index)"
          >
            <div v-show="giftingEnabled && tab.type === 'popularity'" class="tanc" @click="appStore.openModal({ id: 'ranking-rules' })"></div>
            <div class="label-box">
              <span class="label-shadow">{{ tab.name }}</span>
              <span class="label-text">{{ tab.name }}</span>
            </div>
          </UiTab>
        </template>
        <template v-slot:nav-right>

        </template>
        <template v-slot:container>
          <div class="ranking-tabs" :class="{ 'in-teams': records === 2 }">
            <Popularity v-show="records === 0" :dataList="listData" :activeIndex="activeIndex" />
            <Personal   v-show="records === 1" :personaList="personaList" />
            <TeamsList  v-show="records === 2" />
          </div>
        </template>
      </UiBox>
    </div>

    <RankingRules></RankingRules>
    <PopularityRewards></PopularityRewards>
    <PersonalRewards></PersonalRewards>
    <GivePresent />

  </div>
</template>

<script setup>
import { computed, provide, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAppStore, useStageStore } from '@/store'
import { usePrompt } from '@/composables/usePrompt'
import UiBox from '@/components/ui-box';
import UiTab from '@/components/ui-tab';
// 页签命名沿用 UI/URL 一致的 popularity / personal / team, 数据维度上:
//   popularity = 战队人气值累积排行 (每战队汇总)
//   personal   = 个人送礼贡献排行 (每玩家汇总)
//   team       = 战队列表, 点击进入战队详情内页 (/teams/:id)
import Popularity from './popularity'
import Personal from './personal'
import TeamsList from './teams/list'
import RankingRules from './modal/ranking-rules.vue'
import PopularityRewards from './modal/popularity'
import PersonalRewards from './modal/personal'
import GivePresent from '@/views/ranking/modal/present.vue'
import * as api from '@/service/index'

const RANKING_ROUTE_TABS = Object.freeze(['popularity', 'personal', 'team'])
const RANKING_TAB_STORAGE_KEY = 'sausage-match:ranking-tab'

const route = useRoute()
const router = useRouter()
const appStore = useAppStore()
const stageStore = useStageStore()
const { showPrompt } = usePrompt()

const activeTitle = ref([
  { name: '人气排行榜', type: 'popularity' },
  { name: '个人排行榜', type: 'personal' },
  { name: '战队', type: 'team' },
])
// activeType: ['season', 'week', 'preWeek'],
const records = ref(0)
// 战队排行
const listData = reactive({
  clanRank: [],
  personalGifts:{},
  personal:[]
})

const personaList = reactive({
  totalList: [],
  personal:{}
})
const type = ref('season')
const activeIndex = ref(0)

const token = computed(() => appStore.token)
const giftingEnabled = computed(() => stageStore.giftingEnabled)
// 战队 tab 始终有内容, 人气/个人 tab 依赖 giftingEnabled
const isBoxEmpty = computed(() => records.value !== 2 && !giftingEnabled.value)

function getStoredRankingTab() {
  if (typeof window === 'undefined') {
    return ''
  }
  const storedTab = window.sessionStorage.getItem(RANKING_TAB_STORAGE_KEY) || ''
  return RANKING_ROUTE_TABS.includes(storedTab) ? storedTab : ''
}

function persistRankingTab(tab) {
  if (typeof window === 'undefined') {
    return
  }
  window.sessionStorage.setItem(RANKING_TAB_STORAGE_KEY, tab)
}

function getDefaultRankingTab() {
  return getStoredRankingTab() || (giftingEnabled.value ? 'popularity' : 'team')
}

function normalizeRankingTab(tab) {
  return RANKING_ROUTE_TABS.includes(tab) ? tab : getDefaultRankingTab()
}

function getRecordsByTab(tab) {
  return RANKING_ROUTE_TABS.indexOf(normalizeRankingTab(tab))
}

function syncRecordsFromRoute() {
  const routeTab = route.params?.tab
  const nextTab = normalizeRankingTab(routeTab)
  const nextRecords = getRecordsByTab(nextTab)
  persistRankingTab(nextTab)
  if (records.value !== nextRecords) {
    records.value = nextRecords
  }
  if (routeTab !== nextTab) {
    router.replace({
      name: 'Ranking',
      params: {
        tab: nextTab
      },
      query: route.query,
      hash: route.hash
    })
  }
}

function syncRankingTabRoute(index) {
  const nextTab = RANKING_ROUTE_TABS[index] || getDefaultRankingTab()
  if (route.params?.tab === nextTab) {
    return
  }
  router.replace({
    name: 'Ranking',
    params: {
      tab: nextTab
    },
    query: route.query,
    hash: route.hash
  })
}

function honorToggle(index) {
  if (records.value !== index) {
     records.value = index
    syncRankingTabRoute(index)
    switch (records.value) {
      case 0:
        if(giftingEnabled.value) {
          livePersonalRanking()
        }
        break
      case 1:
        if(giftingEnabled.value) {
          getPersonalRankingsList()
        }
        break
      case 2:
        break
      default: ""
    }
  }
}

// 顶部角标 → 综合规则弹窗



async function getGiftTeamDetailFn(teamCode){
  let res = {
    token: token.value,
    teamCode: teamCode,
    rankType:type.value
  }
  try {
    let {data} = await api.getGiftTeamDetail(res)
    listData.personalGifts = data.personal
    listData.personal = data.totalList

    const personal_length = listData.personal.length;
    if(personal_length < 3) {
      for(let i = 0; i < 3 - personal_length; i++) {
        listData.personal.push({
          avatarUrl: '',
          nickName: '-',
          popularity: 0,
          time: 0
        })
      }
    }
  }catch (err) {
    console.log(err)
  }

}

async function livePersonalRanking() {
  if(!token.value) return;
  try {
    activeIndex.value = 0
    let { status, data } = await api.getGiftTeamList(token.value)
    if (status === 200) {
      // 排行数据
      listData.clanRank = data
      // 获取详情数据
      getGiftTeamDetailFn(listData.clanRank[0].teamCode)
    }else{
      // console.log(123)
      showPrompt(data)
    }
  } catch (err) {
    // console.log(err)
    console.log(err)
  }
}


async function getPersonalRankingsList() {
  if(!token.value) return;
  try {
    const {data} = await api.getPersonalRanking(token.value)
    // console.log(data)
    personaList.totalList = data.totalList
    personaList.personal = data.personal
  } catch (err) {
    console.log(err)
  }
}




// 获取战队 个人排行榜
async function getTeamRankingsList(index) {
  activeIndex.value = index ? index : 0
  let count = listData.clanRank[index].teamCode
  getGiftTeamDetailFn(count)
}

provide('getTeamRankingsList', getTeamRankingsList)
provide('honorToggle', honorToggle)

watch(() => route.params.tab, () => {
  syncRecordsFromRoute()
}, { immediate: true })

watch(giftingEnabled, () => {
  syncRecordsFromRoute()
})


// created: 根据 URL 首次进入的 tab 加载对应数据 (records 由 syncRecordsFromRoute 从 URL 解析同步)
// TODO 二阶段开放
switch (records.value) {
  case 0:
    livePersonalRanking()
    break
  case 1:
    getPersonalRankingsList()
    break
}
</script>

<style scoped lang="scss">
.ranking{
  display: flex;
  height: get_percentage(730);

  .ranking-container{
    flex: 1;
    height: 100%;
    overflow: hidden;
    // background-color: #EEEEEE;
    flex-direction: column;
    display: flex;
    // @include boxShadowSet_Container;


    .tab.popularity{
      .tanc{
          position: relative;
          @include r(width, 38);
          @include r(height, 38);
          @include icon_status('icon_rule_event');
          @include r(margin, 4, 8, 0, 0);
      }
    }
  }
  .sidebar{
    margin-right:  get_vh(8);
    height: 100%;
    // width: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    writing-mode: vertical-lr;
    text-orientation: upright;
    letter-spacing:  get_vh(8);
    align-items: center;
    width: get_vh(90);
    .sidebar-nav{
      display: flex;

      li{
        width: get_vh(60);
        height: get_vh(220);
        color: #fff;
        background-color: #2D333A;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-radius: get_vh(10);
        margin-bottom: get_vh(20);;
        @include r(font-size, 24);
        font-weight: 600;
      }
      .records{
        color: #111;
        background-color: #FEE000;
      }
    }
  }

}

.ranking-tabs {
  box-sizing: border-box;
  position: relative;
  height: 100%;
  width: 100%;
  overflow-y: hidden;
  display: flex;
  @include r(padding, 33, 4, 20, 4);

  &.in-teams {
    padding: 0;
  }
}
</style>
